module.exports = __webpack_public_path__ + "static/lato-latin-900italic.a5d2ae3a.woff2";


//////////////////
// WEBPACK FOOTER
// ./~/typeface-lato/files/lato-latin-900italic.woff2
// module id = ./node_modules/typeface-lato/files/lato-latin-900italic.woff2
// module chunks = 17241999800008180000